import { createAsyncThunk } from "@reduxjs/toolkit";
import { ACTION_DOCTOR_WALLET } from "../../action-types/actions";
import { APP_PATH } from "../../api/backendPath";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { getLocalizedErrorMessage } from "../../utils/messageHelper";
import i18n from "../../i18n";

// API: GET /consultation/doctor/wallet/withdrawals
export const fetchDoctorWalletWithdrawalsReducer = createAsyncThunk(
  ACTION_DOCTOR_WALLET.fetch_wallet_withdrawals,
  async (
    { status = "", date_from = "", date_to = "", page = 1, limit = 10 } = {},
    { rejectWithValue },
  ) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const queryParams = new URLSearchParams({
        ...(status && { status }),
        ...(date_from && { date_from }),
        ...(date_to && { date_to }),
        page,
        limit,
      }).toString();

      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}${APP_PATH.getDoctorWalletWithdrawals}?${queryParams}`,
      );

      if (response?.data?.status === true || response?.status === 200) {
        console.log("Withdrawals List Response:", response.data.data);
        return response.data.data;
      } else {
        const message = getLocalizedErrorMessage({ response }, i18n);
        toast.error(message);
        return rejectWithValue(message);
      }
    } catch (error) {
      console.error("Error fetching wallet withdrawals:", error);
      const message = getLocalizedErrorMessage(error, i18n);
      toast.error(message);
      return rejectWithValue(message);
    }
  },
);
